import { FETCH_RESERVATION_FAILURE, FETCH_RESERVATION_REQUEST, FETCH_RESERVATION_SUCCESS, FETCH_ROOM_AVAILABILITY_FAILURE, FETCH_ROOM_AVAILABILITY_REQUEST, FETCH_ROOM_AVAILABILITY_SUCCESS, FETCH_ROOM_FAILURE, FETCH_ROOM_REQUEST, FETCH_ROOM_SUCCESS, GET_ROOM_NUMBER_DETAIL_FAILURE, GET_ROOM_NUMBER_DETAIL_REQUEST, GET_ROOM_NUMBER_DETAIL_SUCCESS } from "../../../Utils/Constant";

export const fetchroomAvailabilityRequest = (payload) => {
    return {
        type: FETCH_ROOM_AVAILABILITY_REQUEST,
        payload: payload,
    };
};

export const fetchroomAvailabilitySuccess = (data) => {
    return {
        type: FETCH_ROOM_AVAILABILITY_SUCCESS,
        payload: data,
    };
};

export const fetchroomAvailabilityFailure = (error) => {
    return {
        type: FETCH_ROOM_AVAILABILITY_FAILURE,
        payload: error,
    };
};


export const fetchroomRequest = (payload) => {
    return {
        type: FETCH_ROOM_REQUEST,
        payload: payload,
    };
};

export const fetchroomSuccess = (data) => {
    return {
        type: FETCH_ROOM_SUCCESS,
        payload: data,
    };
};

export const fetchroomFailure = (error) => {
    return {
        type: FETCH_ROOM_FAILURE,
        payload: error,
    };
};

export const fetchroomReservationsRequest = (payload) => {
    return {
        type: FETCH_RESERVATION_REQUEST,
        payload: payload,
    };
};

export const fetchroomReservationsSuccess = (data) => {
    return {
        type: FETCH_RESERVATION_SUCCESS,
        payload: data,
    };
};

export const fetchroomReservationsFailure = (error) => {
    return {
        type: FETCH_RESERVATION_FAILURE,
        payload: error,
    };
};

export const roomNumberDetailRequest = (payload) => {
    return {
        type: GET_ROOM_NUMBER_DETAIL_REQUEST,
        payload: payload,
    };
};

export const roomNumberDetailSuccess = (data) => {
    return {
        type: GET_ROOM_NUMBER_DETAIL_SUCCESS,
        payload: data,
    };
};

export const roomNumberDetailFailure = (error) => {
    return {
        type: GET_ROOM_NUMBER_DETAIL_FAILURE,
        payload: error,
    };
};